import _defineProperty from "/builds/haesh/it-infrastructure/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/haesh/it-infrastructure/website/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/builds/haesh/it-infrastructure/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/builds/haesh/it-infrastructure/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["passive"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import p, { createContext as m, useContext as L, useMemo as f, useState as b } from "react";
import { useId as g } from "../../hooks/use-id.js";
import { forwardRefWithAs as x, render as T } from "../../utils/render.js";
import { useIsoMorphicEffect as E } from "../../hooks/use-iso-morphic-effect.js";
import { useSyncRefs as P } from "../../hooks/use-sync-refs.js";
import { useEvent as v } from "../../hooks/use-event.js";
var u = m(null);

function c() {
  var o = L(u);

  if (o === null) {
    var t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, c), t;
  }

  return o;
}

function M() {
  var _b = b([]),
      _b2 = _slicedToArray(_b, 2),
      o = _b2[0],
      t = _b2[1];

  return [o.length > 0 ? o.join(" ") : void 0, f(function () {
    return function (e) {
      var l = v(function (a) {
        return t(function (i) {
          return [].concat(_toConsumableArray(i), [a]);
        }), function () {
          return t(function (i) {
            var n = i.slice(),
                d = n.indexOf(a);
            return d !== -1 && n.splice(d, 1), n;
          });
        };
      }),
          r = f(function () {
        return {
          register: l,
          slot: e.slot,
          name: e.name,
          props: e.props
        };
      }, [l, e.slot, e.name, e.props]);
      return p.createElement(u.Provider, {
        value: r
      }, e.children);
    };
  }, [t])];
}

var h = "label",
    F = x(function (t, s) {
  var _t$passive = t.passive,
      e = _t$passive === void 0 ? !1 : _t$passive,
      l = _objectWithoutProperties(t, _excluded),
      r = c(),
      a = "headlessui-label-".concat(g()),
      i = P(s);

  E(function () {
    return r.register(a);
  }, [a, r.register]);

  var n = _objectSpread(_objectSpread({
    ref: i
  }, r.props), {}, {
    id: a
  });

  return e && ("onClick" in n && delete n.onClick, "onClick" in l && delete l.onClick), T({
    ourProps: n,
    theirProps: l,
    slot: r.slot || {},
    defaultTag: h,
    name: r.name || "Label"
  });
});
export { F as Label, M as useLabels };